export const USER_MODEL = 'user';

export interface User {
  id: number;
  name: string;
  email: string;
  language?: string;
  timezone?: string;
  country?: string;
  migration_flags?: any;
  has_used_trial?: boolean;
  ads?: {
    general_top?: string;
    general_bottom?: string;
    artist_top?: string;
    artist_bottom?: string;
    album_above?: string;
    disable?: boolean;
    audio?: {
      zone?: number;
      playTimeRef?: number
    };
  };
}

export interface CompactUser {
  id: number;
  name: string;
  image?: string;
}

export interface CompactUserWithEmail extends CompactUser {
  email: string;
}
